import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const ModalActionsWrapper = styled.div`
  padding: ${Spacing.S12};
`

export const RightActionsWrapper = styled.div`
  margin-left: auto;
`
